import React, { useCallback } from 'react';
import {
  makeStyles, mergeClasses, shorthands, tokens,
} from '@fluentui/react-components';
import { ColorfulButton } from './ColorfulButton';
import { Checkmark } from './images/Checkmark';

export interface ISingleTextSuggestionProps {
  text: string;
  onSelect: (param: { value: string }) => void;
  buttonText?: string;
  className?: string;
}

const useSingleTextSuggestionStyles = makeStyles({
  root: {
    paddingTop: tokens.spacingHorizontalS,
    paddingBottom: tokens.spacingHorizontalS,
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    display: 'flex',
    alignItems: 'flex-start',
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    ...shorthands.border('1px', 'solid', '#E1DFDD'),
  },
  text: {
    color: '#201F1E',
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    marginRight: tokens.spacingVerticalXL,
    ...shorthands.flex(1),
  },
  icon: {
    marginRight: tokens.spacingVerticalXS,
  },
});

export const SingleTextSuggestion: React.FC<ISingleTextSuggestionProps> = React.memo(({
  text, onSelect, buttonText, className,
}) => {
  const styles = useSingleTextSuggestionStyles();
  const onClick = useCallback(() => {
    onSelect({ value: text });
  }, [onSelect, text]);

  return (
    <div className={mergeClasses('inline-copilot-suggestion', styles.root, className)}>
      <span className={mergeClasses(styles.text, 'inline-copilot-suggestion-text')}>{text}</span>
      <ColorfulButton className="inline-copilot-suggestion-button" onClick={onClick} size="small">
        <Checkmark className={styles.icon} />
        {buttonText}
      </ColorfulButton>
    </div>
  );
});

SingleTextSuggestion.defaultProps = {
  buttonText: 'Add this',
  className: '',
};
